module.exports = __webpack_public_path__ + "media/images/iconTrend--up-d5ff86f613165105006bf8ed6d02b83d.png";